export const MINIMUM_NEW_FINANCING_REQUIRED = 100_000;
export const MINIMUM_REFI_FINANCING_REQUIRED = 125_000;
export const MAX_LENDING_AMOUNT_RATIO = 0.8;
